export enum Orientation {
  Horizontal = "horizontal",
  Vertical = "vertical"
}

export const CardOrientationQueryParam = "cardDisplay";

export const CardOrientationDefault = Orientation.Vertical;
